import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 71 68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M69.351 11.322 35.601.072a1.4 1.4 0 0 0-.89 0L.962 11.322q-.03.012-.057.025a1.5 1.5 0 0 0-.234.116q-.036.021-.07.044-.09.063-.168.139l-.023.019q-.086.088-.156.19-.02.031-.04.064a1.4 1.4 0 0 0-.167.4q-.011.04-.02.08-.025.128-.026.257v28.125a1.406 1.406 0 1 0 2.813 0V14.607l15.424 5.142a21.087 21.087 0 0 0 8.577 31.965 32.28 32.28 0 0 0-18.77 13.611 1.406 1.406 0 1 0 2.356 1.536 29.54 29.54 0 0 1 49.512 0 1.406 1.406 0 1 0 2.356-1.536 32.28 32.28 0 0 0-18.77-13.61 21.088 21.088 0 0 0 8.577-31.966l17.276-5.759a1.407 1.407 0 0 0 0-2.668M53.438 32.344a18.28 18.28 0 1 1-32.369-11.651l13.643 4.547c.288.097.6.097.889 0l13.642-4.547a18.23 18.23 0 0 1 4.194 11.65M49.22 17.735l-.004.002-14.06 4.687-29.304-9.768L35.156 2.89l29.303 9.767z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "student"}) } }